<template lang="pug">
    v-container.text-center(fluid dark)
        line-chart(:chart-data="dataChart" :options="options")
</template>

<script>
    import LineChart from '@/plugins/charts/LineChart.js'

    export default {
        components: {
            LineChart
        },
        props:{
            chart:{
                type: Array,
                default: function(){
                  return []
                }
            }
        },
        computed:{
          dataChart(){
              return{
                  datasets: [
                      {
                          label: 'Monthly/Daily Users',
                          pointBackgroundColor: `rgba(220,220,220, 1)`,
                          pointBorderColor:'rgba(255,255,255,1)',
                          backgroundColor:'rgba(220,220,220,0.4)',
                          borderColor:`rgba(220,220,220, 1)`,
                          data: this.chart.slice().sort(function(a, b) {
                              var dateA = new Date(a.x), dateB = new Date(b.x);
                              return dateA - dateB;
                          })
                      }
                  ]
              }
          },
        },
        data () {
            return {
                datacollection: {},
                options:{
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        labels: {
                            fontColor: "white"
                        }
                    },
                    tooltips: {
                        mode: 'index',
                        intersect: false
                    },
                    scales:{
                        xAxes: [{
                            type:"time",
                            distribution: 'linear',
                            gridLines: {
                                drawOnChartArea: false, // only want the grid lines for one axis to show up
                            },
                            ticks: {
                                fontColor: "white",
                            },
                            time: {
                                displayFormats: {
                                    'millisecond': 'MMM DD',
                                    'second': 'MMM DD',
                                    'minute': 'MMM DD',
                                    'hour': 'MMM DD',
                                    'day': 'MMM DD',
                                    'week': 'MMM DD',
                                    'month': 'MMM DD',
                                    'quarter': 'MMM DD',
                                    'year': 'MMM DD',
                                }
                            }
                        }],
                        yAxes: [{
                            scaleLabel: {
                                display:     false,
                                labelString: 'value'
                            },
                            gridLines: {
                               color:'rgba(255,255,255,0.3)'
                            },
                            ticks: {
                                fontColor: "white",
                            }
                        }]
                    }
                }
            }
        },
        mounted () {
            this.fillData()
        },
        methods: {
            fillData () {
                this.datacollection = {

                }
            },
            getRandomInt () {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            }
        }
    }
</script>
